const TYR = {
    CUSTOMER_COUNTRY_CODE: 'tyrCustomerCountryCode',
    CUSTOMER_TARGET_DOMAIN: 'tyrTargetDomain'
}

export default TYR;